import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { StatusIndicatorTitle } from "../../../Constants/Constants";
import { AvatarStatusData, StatusSubTitle } from "../../../Data/UiKits/Avatars";

const StatusIndicator = () => {
  return (
    <Col xl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader title={StatusIndicatorTitle} span={StatusSubTitle} />
        <CardBody>
          <div className="avatars avatar-showcase">
            {AvatarStatusData &&
              AvatarStatusData.map((item, index) => (
                <div className="avatar" key={index}>
                  <Image className={`img-${item.class} rounded-circle`} src={dynamicImage(item.image)} alt="user profile" />
                  <div className={`status bg-${item.status}`} />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default StatusIndicator;
